import { useEffect } from 'react';

function AlertBadge({ alert = {}, className = '' }) {
  const { isOpen, message, variant, duration, onClose } = alert || {};

  useEffect(() => {
    if (!isOpen) return;
    if (!duration || duration <= 0) return;

    const timerId = setTimeout(() => {
      onClose && onClose();
    }, duration);

    return () => clearTimeout(timerId);
  }, [isOpen, duration, onClose]);

  if (!isOpen) return null;

  return (
    <div className={`alert-badge ${variant} ${className}`}>
      <span>{message}</span>
    </div>
  );
}

export default AlertBadge;
